<div class="trans-jobs-container">
  <table class="gt-reclass-table table table-condensed">
    <thead>
      <tr>
        <th colspan="16" class="header-title">Trans Jobs</th>
      </tr>
    </thead>
  </table>

  <div class="form-section">
    <!-- Tax Year / Scenario Row -->
    <div class="controls-row">
      <div class="control-group">
        <label>Tax Year</label>
        <select class="form-control compact-select"
                [(ngModel)]="selectedTaxYear"
                (ngModelChange)="getScenarioDropDown()">
          <option value="" disabled selected>Select Tax Year</option>
          @for (taxyr of filteredTaxYearData; track $index) {
<option
                  [value]="taxyr.CODE_DISP_DESC">
            {{ taxyr.CODE_DISP_DESC }}
          </option>
}
        </select>
      </div>

      @if (showscenario) {
<div class="control-group">
        <label>Scenario</label>
        <select class="form-control compact-select scenario-select"
                [(ngModel)]="selectedScenario"
                (ngModelChange)="onScenarioChange()">
          <option value="" disabled selected>Select Scenario</option>
          @for (option of scenarioDropDown; track $index) {
<option
                  [value]="option.VALUE">
            {{ option.LABEL }}
          </option>
}
        </select>
      </div>
}
    </div>

    <!-- Trans Types Toggle Table -->
    @if (showTransTypes && trans_types.length > 0) {
<table class="trans-table">
      <tbody>
        @for (t of trans_types; track $index) {
<tr>
          <td class="type-name">{{ t.GROUP_NAME }}</td>
          <td class="type-toggle">
            <div class="switch-wrapper"
                 [class.switch-on]="t.IS_ENABLED"
                 [class.switch-off]="!t.IS_ENABLED"
                 [class.switch-disabled]="savingGroupKey !== null"
                 (click)="toggleTransJob(t)">
              <span class="switch-label">{{ t.IS_ENABLED ? 'On' : 'Off' }}</span>
              <span class="switch-knob"></span>
            </div>
            @if (savingGroupKey === t.GROUP_KEY) {
<i
               class="fa fa-spinner fa-spin saving-spinner"></i>
}
          </td>
        </tr>
}
      </tbody>
    </table>
}
  </div>
</div>
